export const officialSiteMenuClickEventMap: Record<string, string> = {
	home: 'click/firstpage_menu',
	about: 'click/about_menu',
	category_75182625: 'click/yoga_menu',
	yoga: 'click/yoga_menu',
	category_393378225: 'click/gongfa_menu',
	skills: 'click/gongfa_menu',
	category_24671985: 'click/photography_menu',
	photography: 'click/photography_menu',
	ruralLibrary: 'click/public_menu',
	interestInclusion: 'click/interest_menu',
	socialGuardian: 'click/social_menu',
	news: 'click/offweb_news_menu',
};

export const officialSiteMobileMenuClickEventMap: Record<string, string> = {
	home: 'click/firstpage_h5',
	about: 'click/about_h5',
	category_75182625: 'click/yoga_h5',
	yoga: 'click/yoga_h5',
	category_393378225: 'click/gongfa_h5',
	skills: 'click/gongfa_h5',
	category_24671985: 'click/photography_h5',
	photography: 'click/photography_h5',
	ruralLibrary: 'click/public_h5',
	interestInclusion: 'click/interest_h5',
	socialGuardian: 'click/social_h5',
	news: 'click/offweb_news_h5',
};

export const officialSiteCategoryPageTrackMap: Record<
	string,
	{
		pv: string;
		dwelltime: string;
		more?: string;
	}
> = {
	75182625: {
		pv: 'view/yoga',
		dwelltime: 'exposure/yoga',
		more: 'click/yoga_more',
	},
	393378225: {
		pv: 'view/gongfa',
		dwelltime: 'exposure/gongfa',
		more: 'click/gongfa_more',
	},
	24671985: {
		pv: 'view/photography',
		dwelltime: 'exposure/photography',
		more: 'click/photography_more',
	},
};

export const officialSiteMobileCategoryPageTrackMap: Record<
	string,
	{
		pv: string;
		dwelltime: string;
		more?: string;
	}
> = {
	75182625: {
		pv: 'view/yoga_h5',
		dwelltime: 'exposure/yoga_h5',
		more: 'click/yoga_more_h5',
	},
	393378225: {
		pv: 'view/gongfa_h5',
		dwelltime: 'exposure/gongfa_h5',
		more: 'click/gongfa_more_h5',
	},
	24671985: {
		pv: 'view/photography_h5',
		dwelltime: 'exposure/photography_h5',
		more: 'click/photography_more_h5',
	},
};

export function getOfficialSiteMenuClickEventId(code: string): string {
	return officialSiteMenuClickEventMap[code] || '';
}

export function getOfficialSiteMobileMenuClickEventId(code: string): string {
	return officialSiteMobileMenuClickEventMap[code] || '';
}

export function getOfficialSiteCategoryPageTrack(categoryId: string): any {
	return officialSiteCategoryPageTrackMap[categoryId] || null;
}

export function getOfficialSiteMobileCategoryPageTrack(categoryId: string): any {
	return officialSiteMobileCategoryPageTrackMap[categoryId] || null;
}

export function getOfficialSiteNewsCardClickEventId(position: number): string {
	if (position < 1 || position > 9) {
		return '';
	}

	return `click/offweb_news_${position}card`;
}

export function getOfficialSiteMobileNewsCardClickEventId(position: number): string {
	if (position < 1 || position > 6) {
		return '';
	}

	return `click/offweb_news_h5_${position}card`;
}
